import { buildDatasetMetadata, MULTIPART_PART_BYTES } from './metadata';
import { removeDatasetReceipt, saveDatasetReceipt } from './receipts';

async function json(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || `Dataset request failed (${response.status}).`);
  return body;
}

export async function uploadDatasetContribution(file, details = {}) {
  const metadata = await buildDatasetMetadata(file, details);
  const created = await json(await fetch('/api/dataset/submissions', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(metadata),
  }));
  let parts = [];

  if (created.upload.mode === 'single') {
    const response = await fetch(created.upload.url, { method: 'PUT', headers: created.upload.headers, body: file });
    if (!response.ok) throw new Error('No s’ha pogut pujar l’àudio al corpus.');
  } else {
    const partNumbers = Array.from({ length: Math.ceil(file.size / MULTIPART_PART_BYTES) }, (_, index) => index + 1);
    const signed = await json(await fetch(`/api/dataset/submissions/${created.submissionId}/parts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Submission-Token': created.token },
      body: JSON.stringify({ partNumbers }),
    }));
    for (const part of signed.parts) {
      const start = (part.partNumber - 1) * MULTIPART_PART_BYTES;
      const response = await fetch(part.url, {
        method: 'PUT',
        body: file.slice(start, Math.min(start + MULTIPART_PART_BYTES, file.size)),
      });
      if (!response.ok) throw new Error(`No s’ha pogut pujar la part ${part.partNumber}.`);
      const eTag = response.headers.get('ETag');
      if (!eTag) throw new Error(`R2 no ha retornat l’ETag de la part ${part.partNumber}.`);
      parts.push({ partNumber: part.partNumber, eTag });
    }
  }

  const completed = await json(await fetch(`/api/dataset/submissions/${created.submissionId}/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Submission-Token': created.token },
    body: JSON.stringify({ checksumSha256: metadata.checksumSha256, parts }),
  }));
  return saveDatasetReceipt({ submissionId: created.submissionId, token: created.token, createdAt: completed.createdAt });
}

export const getDatasetContribution = (submissionId, token) => fetch(
  `/api/dataset/submissions/${submissionId}`,
  { headers: { 'X-Submission-Token': token } },
).then(json);

export async function deleteDatasetContribution(submissionId, token) {
  await json(await fetch(`/api/dataset/submissions/${submissionId}`, {
    method: 'DELETE', headers: { 'X-Submission-Token': token },
  }));
  removeDatasetReceipt(submissionId);
}
